import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './config/redux/store';
import { Title } from './components';
import { EmbarkyProvider } from '@embarky/react';
import embarkyConfig from './config/embarky';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EmbarkyProvider config={embarkyConfig}>
      <Provider store={store}>
        <Title />
        <App />
      </Provider>
    </EmbarkyProvider>
  </React.StrictMode>
);
